import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { desktop, mobile } from "../../const/sizes";
import { BACKGROUND_SECONDARY, WHITE } from "../../const/colors";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            minHeight: `calc(100vh - 0px)`,
            padding: `0 ${desktop.contentLargerSpacing}`,
            paddingTop: desktop.contentLargerSpacing,
            backgroundColor: WHITE,
            width: '100%',
        },
        link: {
            cursor: 'pointer',
        },
        errorText: { 
            color: theme.palette.error.main,
            fontSize: 14, 
            marginLeft: 10, 
            marginTop: 4 
        },
        removeButtonContainer: {
            display: 'flex', alignItems: 'flex-start'
        },
        sectionTitle: {
            fontSize: 20,
        },
        [theme.breakpoints.down('sm')]: {
            container: {
                padding: `0 ${mobile.contentLargerSpacing}`,
                minHeight: `calc(100vh - 128px)`,
            },
            secondaryBlockContainer: {
                marginTop: 0,
                marginBottom: 0,
                borderTop: '10px solid ' + BACKGROUND_SECONDARY,
                // borderBottom: '10px solid ' + BACKGROUND_SECONDARY,
            },
            removeButtonContainer: {
                display: 'flex', 
                justifyContent: 'center',
            },
            mobileSpacer: {
                width: '100%',
                height: 20,
                backgroundColor: BACKGROUND_SECONDARY,
            }
        },
    }),
);

export default useStyles;